import {addAuthToFetchOpts} from '../config/queryopts'
import {useMutationWithAuthentication} from "./index";
import {apiUrlInternal} from "../config/api"
import axios from "axios";
import {useQueryClient} from "react-query";


export const AddFlashAlertFetcher = (accessToken, params) => {
  return axios.post(`${apiUrlInternal}/flash_alerts`, params, addAuthToFetchOpts(accessToken, {}, 0)).then(res => res.data);
}

export const useAddFlashAlertMutation = (fetcher = AddFlashAlertFetcher) => {
  const queryClient = useQueryClient();
  return useMutationWithAuthentication(
    ['add-flashalert'],
    (accessToken, params) => fetcher(accessToken, params),
    {onSuccess: () => queryClient.invalidateQueries('add-flashalert')}
  )
}

